import {
    Directive, ElementRef, EventEmitter, HostListener, Input,
    Output,
    ChangeDetectorRef, NgZone, OnInit
} from '@angular/core';

@Directive({
  selector: '[genEllipsis]'
})
export class EllipsisDirective implements OnInit{
  private recheck: boolean;

  @Input() set reapply(shouldReapply) {
    if(this.recheck === shouldReapply){
        return;
    }
    this.recheck = !!shouldReapply;
    this._zone.runOutsideAngular(() => {
      setTimeout(() => {
          if(this.recheck) {
              this.toggleOffRecheck();
              this.check();
          }
      }, 0);
    });
  }

  @Input() set tooltipShow(value) {
    this.show = value;
    this.tooltipStateEmit.emit(this.show);
  }

  get tooltipShow() {
    return this.show;
  }

  @Output() tooltipStateEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() reapplyChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public ellipsisStyle: string = 'text-overflow: ellipsis; display: block; overflow: hidden; white-space: nowrap;';
  private show: boolean;

  constructor(private element: ElementRef, private changeDetector: ChangeDetectorRef,
              private _zone: NgZone
              ) {
  }

  ngOnInit(){
      this.reapply = (this.recheck === null || this.recheck === undefined) ? true : this.recheck; // default initiation
  }

  @HostListener('window:resize')
  check() {
    if(this.element.nativeElement.offsetWidth === 0){
          return;
    }
    this.element.nativeElement.setAttribute('style', this.ellipsisStyle);
    if (this.checkOverflow()) {
        if(!this.tooltipShow && this.element.nativeElement.hasAttribute('genTooltip')) {
            this.tooltipShow = true;
            this.toggleOffRecheck();
            this.changeDetector.markForCheck();
            this.changeDetector.detectChanges();
      }
    }
    else {
      this.element.nativeElement.removeAttribute('style');
      this.tooltipShow = false;
      this.changeDetector.markForCheck();
    }
  }

  checkOverflow() {
    if (this.element.nativeElement.offsetHeight < this.element.nativeElement.scrollHeight ||
      this.element.nativeElement.offsetWidth < this.element.nativeElement.scrollWidth) {
      return true;
    } else {
      return false;
    }
  }

  toggleOffRecheck() {
      this.recheck = false;
      this.reapplyChange.emit(false);
  }


}
